$(document).ready(function () {
  let p = $("body").attr("p");
  let event_id = $("body").attr("event_id");
  let startDate = $("#start-date").val();
  let endDate = $("#end-date").val();
  let alcohol_report_ajax_lock = false;
  if (p == "alcohol_report") {
    $(document).on("click", "#alcohol-report-downlod-excel-btn", function (e) {
      startDate = $("#start-date").val();
      endDate = $("#end-date").val();

      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css("width", btnWidth + "px");
      disabledOnClick.prop("disabled", true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      $.ajax({
        url: "/api/v1/private/order_product/download-alcohol-report-excel",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({
          start_date: startDate,
          end_date: endDate,
          location_id: locationId,
        }),
        xhrFields: { responseType: "blob" }, // receive binary data
        success: function (data) {
          if (window.ReactNativeWebView) {
            // Convert blob to base64
            const reader = new FileReader();
            reader.onloadend = function () {
              const base64Data = reader.result.split(',')[1];
                const filename = `Alkoholrapport (${startDate.replace(/[:_]/g, "-") + "-" + endDate.replace(/[:_]/g, "-")}).xlsx`;

              // Send to React Native
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  action: 'download',
                  data: {
                    base64Data,
                    filename: filename,
                    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                  }
                })
              );
            };
            reader.readAsDataURL(data);
          } else {
            const blob = new Blob([data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `Alkoholrapport (${startDate + "-" + endDate}).xlsx`;
            link.click();
          }
        },
        error: function (xhr) {
          if (
            xhr.responseJSON.redirect_url !== undefined &&
            xhr.responseJSON.redirect_url !== null
          ) {
            document.location.href = xhr.responseJSON.redirect_url;
            return;
          }
          alert("Error generating Excel file");
        },
        complete: function () {
          disabledOnClick.prop("disabled", false);
          disabledOnClick.html("Last ned(excel)");
        },
      });
    });

    $("#start-date").datetimepicker({
      controlType: 'select',
      oneLine: true,
      dateFormat: 'yy-mm-dd',
      timeFormat: 'HH:mm:ss',
      showButtonPanel: false,
      onClose: function () {
        if (startDate !== $(this).val()) {
          handleDateChange();
        }
      },
    });

    // Initialize the Datepicker for end-date
    $("#end-date").datetimepicker({
      controlType: 'select',
      oneLine: true,
      dateFormat: 'yy-mm-dd',
      timeFormat: 'HH:mm:ss',
      showButtonPanel: false,
      onClose: function () {
        if (endDate !== $(this).val()) {
          handleDateChange();
        }
      },
    });

    function handleDateChange() {
      startDate = $("#start-date").val();
      endDate = $("#end-date").val();
      if (dateAndPeriodValidation) {
        search(startDate, endDate);
      }
    }

    function dateAndPeriodValidation(startedDate, endedDate) {
      let start = moment(startedDate);
      let end = moment(endedDate);
      durationOfstartAndEndDateByMonths = moment(endedDate.split(" ")[0]).diff(
        startedDate.split(" ")[0],
        "months"
      );

      if (start.isAfter(end)) {
        $("#start-date").val(startDate);
        $("#end-date").val(endDate);
        return alert("end date cannot be later than start date");
      } else if (durationOfstartAndEndDateByMonths > 36) {
        $("#start-date").val(startDate);
        $("#end-date").val(endDate);
        return alert("Maksimal varighet er 3 år");
      } else {
        return true;
      }
    }

    function search(startDate, endDate) {
      if (!alcohol_report_ajax_lock) {
        alcohol_report_ajax_lock = true;

        $.ajax({
          type: "POST",
          url: "/api/v1/private/order_product/get-alcohol-report",
          data: {
            start_date: startDate,
            end_date: endDate,
            location_id: locationId,
          },
        })
          .done(function (data) {
            if (
              data.html != undefined &&
              data.html != null &&
              data.html != ""
            ) {
              $("#alcohol-report-key-figures").empty();
              $("#alcohol-report-key-figures").html(data.html);
            }
          })
          .fail(function (xhr) {
            if (
                xhr.responseJSON.redirect_url !== undefined &&
                xhr.responseJSON.redirect_url !== null
            ) {
                document.location.href = xhr.responseJSON.redirect_url;
                return;
            }
          })
          .always(function () {
            alcohol_report_ajax_lock = false;
          });
      }
    }
  }
});
